function Loader() {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <h1>Loading Questions...</h1>
    </div>
  );
}

export default Loader;
